import type { Bounds } from 'pixi-viewport';

/**
 * Shrink bounds by given factor
 *
 * All sides are moved by given factor, maintaining the center.
 * For example, factor 0.05 will remove 5% of width/height from each side.
 */
export const shrinkBounds =
  (factor: number) =>
  (bounds: Bounds): Bounds => ({
    x: bounds.x + bounds.width * factor,
    y: bounds.y + bounds.height * factor,
    width: bounds.width * (1 - 2 * factor),
    height: bounds.height * (1 - 2 * factor),
  });
